import React, { useEffect } from 'react'
import { IRequestedItem, ItemsRequestModel } from '.'
import { RequestedItem } from './SelectRequestedItems'
import { Alert, Avatar } from '@mui/material'
import NoThumb from "../../assets/svg/no-thumb.svg"
import GenerateIcon from '../../components/GenerateIcon'
import { useLocation } from 'react-router-dom'
import StatusChip from '../../components/StatusChip'
import { handleCloseElementQuickPreview, handleOpenElementQuickPreview } from '../admin/adminPagesSlice'
import ItemsApp from '../items/ItemsApp'
import { useDispatch } from 'react-redux'
import Thumbnail from '../../components/Thumbnail'
import NothingFound from '../../components/NothingFound'

interface IRequestedMissingItemBoxProps {
    requestedItem: IRequestedItem,
    showDamaged?: boolean,
    showRejected?: boolean,
}

export function RequestedMissingItemBox(props: IRequestedMissingItemBoxProps){

    const dispatch = useDispatch()

    const { requestedItem, showDamaged, showRejected } = props
    const { item_id, item, allocations, quantity, damaged, missing } = requestedItem

    const location = useLocation()
    const isItemRequestPage = location.pathname.includes("/panel/item_requests")

    let statusType: string = "missing"
    let qnt: number = missing
    let title: string = "Missing Qnt."

    if (showDamaged){
        statusType = "damaged"
        title = "Damaged Qnt."
        qnt = damaged
    }

    if (showRejected){
        statusType = "rejected"
        title = "Rejected Qnt."
        qnt = quantity
    }

    return(
        <div className="requsted-item-wrapper">

            <div className="requsted-item-box-container">
                <div className="content-of-requsted-item-box-container">

                    <div className="fields-of-requsted-item-box-container">
                        <div className="content-of-fields-of-requsted-item-box-container">

                            <div className="field-of-requsted-item-box-container thumbnail">
                                <div className="content-of-field-of-requsted-item-box-container">
                                    {/* <Avatar src={item.thumbnail ? item.thumbnail : NoThumb}>
                                        <GenerateIcon icon="image" />
                                    </Avatar> */}
                                    <Thumbnail src={item.thumbnail ? item.thumbnail : NoThumb} />
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text">
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <StatusChip type={statusType} />
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Item</h4>
                                    {/* <a href={isItemRequestPage ? `/panel/items/view/${item.unique_id}` : `/items/${item.unique_id}`} target="_blank"><h3>{item.title}</h3></a> */}
                                    <h3 style={{ cursor: "pointer" }} onClick={() => {
                                        handleOpenElementQuickPreview(
                                            item.id,
                                            item.title,
                                            () => new ItemsApp(),
                                            dispatch,
                                            [
                                                {
                                                    label: "Close",
                                                    color: "error",
                                                    onClick: () => handleCloseElementQuickPreview(dispatch)
                                                }
                                            ],
                                            false,
                                            undefined,
                                            true
                                        )
                                    }}>{item.title}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Unique ID</h4>
                                    <h3>{item.unique_id}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Serial Number</h4>
                                    <h3>{item.serial_number ? item.serial_number : "-"}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text error" style={{ minWidth: 120, maxWidth: 120 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>{title}</h4>
                                    <h3>{qnt}</h3>
                                </div>
                            </div>

                        </div>
                    </div>
{/* 
                    {!viewRequestPage ? (
                      <div className="action-buttons-of-requsted-item-box-container">
                          <div className="content-of-action-buttons-of-requsted-item-box-container">

                              <Button className="general-button admin-button" color="success" onClick={() => setOpen(true)}>Update Quantity</Button>
                              <Button className="general-button admin-button" color="error" onClick={() => deleteItem(item_id)}>Delete</Button>

                          </div>
                      </div>
                    ) : (
                        <div className="action-buttons-of-requsted-item-box-container">
                            <div className="content-of-action-buttons-of-requsted-item-box-container">

                              {showReportButton && <Button className="general-button admin-button" color="error" onClick={() => showReport(requestedItem)}>Report</Button>}

                            </div>
                        </div>
                    )} */}

                </div>
            </div>

        </div>
    )
}

interface IRequestedMissingItemsProps {
    items: IRequestedItem[],
    viewRequestPage?: boolean,
    request: ItemsRequestModel,
    loadingItems: boolean,
    showDamaged?: boolean,
    showRejected?: boolean,
    hideTitle?: boolean,
}

export default function RequestedMissingItems(props: IRequestedMissingItemsProps) {

    const { 
        items,
        viewRequestPage,
        request,
        loadingItems,
        showDamaged,
        showRejected,
        hideTitle
    } = props

    let title: string = "Missing Items"

    const itemsWithMissing = items.filter(item => (item.missing ?? 0) > 0)
    const itemsWithDamaged = items.filter(item => (item.damaged ?? 0) > 0)
    const itemsWithRejected = items.filter(item => item.is_rejected === true)

    let message: string = "No items have been found"

    let list = itemsWithMissing


    if (showDamaged){
        list = itemsWithDamaged
        title = "Damaged Items"
        message = "No damaged items have been found."
    }

    if (showRejected){
        title = "Rejected Items"
        list = itemsWithRejected
        message = "No rejected items have been found"
    }

    if (loadingItems){
        return <></>
    }

    if (list.length === 0){
        return <Alert color='info'>{message}</Alert>
    }

    return(
        <div className="requsted-items-of-single-items-request-page-container missing-items">
            
            {!hideTitle && <h3 className="requested-items-title">{title} ({list.length})</h3>}

            <div className="content-of-requested-items-container">
            
                <div className="requested-items-list">
                    {list.map((item, index: number) => <RequestedMissingItemBox requestedItem={item} key={index} showDamaged={showDamaged} showRejected={showRejected} />)}
                </div>
            
            </div>
        </div>
    )
}